import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "primereact/button";

import { faRightToBracket, faRotate } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { translationKeys } from "../../../models/app-translation-keys";

import "./UnauthorizedPage.scss";

interface IUnauthorizedPageProps {
  redirectToLogin: () => Promise<void>;
  errors?: string | null;
}

export const UnauthorizedPage: FunctionComponent<IUnauthorizedPageProps> = (props: IUnauthorizedPageProps) => {
  const { t } = useTranslation();

  const redirectToLogin = () => {
    props.redirectToLogin();
  };

  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className="page-unauthorized">
      <h1>{t(translationKeys.pages.unauthorized.title)}</h1>

      <p>{t(translationKeys.pages.unauthorized.description)}</p>

      {!!props.errors && <div className="errors">{props.errors.toString()}</div>}

      <div className="buttons">
        <Button
          onClick={redirectToLogin}
          label={t(translationKeys.pages.unauthorized.redirectToLogin)}
          icon={<FontAwesomeIcon icon={faRightToBracket} />}
        />

        <Button
          onClick={reloadPage}
          label={t(translationKeys.pages.unauthorized.reloadPage)}
          icon={<FontAwesomeIcon icon={faRotate} />}
        />
      </div>
    </div>
  );
};
